import React from 'react';
import { styled } from '@mui/material';

import { useTask } from 'contexts/task';
import { useViewport } from 'contexts/viewport';
import { Box, Icon, Stack, Text } from 'shell/components';

const TaskStatistics = ({ className, ...rest }) => {
    const { taskList, getOverdueTasks } = useTask();
    const { device } = useViewport();

    const complete = taskList.completed.length;
    const incomplete = taskList.toDo.length + taskList.inProgress.length + taskList.underReview.length;
    const overdue = getOverdueTasks().length;
    const alltasks =
        taskList.completed.length + taskList.toDo.length + taskList.underReview.length + taskList.inProgress.length;

    return (
        <RootStack className={className} alignItems={'center'} device={device} justifyContent={'center'} {...rest}>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', width: '100%' }}>
                <Stack alignItems={'center'} spacing={2}>
                    <IconStack alignItems={'center'} kind={'checkmark'} justifyContent={'center'}>
                        <CustomIcon kind={'checkmark'} />
                    </IconStack>
                    <Stack alignItems={'center'}>
                        <Text variant={'h6'}>{complete.toString()}</Text>
                        <Text color={'light'} variant={'p1'}>
                            Complete
                        </Text>
                    </Stack>
                </Stack>
                <Stack alignItems={'center'} spacing={2}>
                    <IconStack alignItems={'center'} kind={'stopWatch'} justifyContent={'center'}>
                        <CustomIcon kind={'stopWatch'} />
                    </IconStack>
                    <Stack alignItems={'center'}>
                        <Text variant={'h6'}>{incomplete.toString()}</Text>
                        <Text color={'light'} variant={'p1'}>
                            Incomplete
                        </Text>
                    </Stack>
                </Stack>
                <Stack alignItems={'center'} spacing={2}>
                    <IconStack alignItems={'center'} kind={'error'} justifyContent={'center'}>
                        <CustomIcon kind={'error'} />
                    </IconStack>
                    <Stack alignItems={'center'}>
                        <Text variant={'h6'}>{overdue.toString()}</Text>
                        <Text color={'light'} variant={'p1'}>
                            Overdue
                        </Text>
                    </Stack>
                </Stack>
                <Stack alignItems={'center'} spacing={2}>
                    <IconStack alignItems={'center'} kind={'task'} justifyContent={'center'}>
                        <CustomIcon kind={'task'} />
                    </IconStack>
                    <Stack alignItems={'center'}>
                        <Text variant={'h6'}>{alltasks.toString()}</Text>
                        <Text color={'light'} variant={'p1'}>
                            All Tasks
                        </Text>
                    </Stack>
                </Stack>
            </Box>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ device, theme }) => {
    return {
        padding: theme.spacing(5),
        background: theme.palette.ensightful.shades[0],
        ...(device === 'mobile' && {
            width: '100%',
        }),
    };
});

const IconStack = styled(Stack)(({ kind, theme }) => {
    return {
        borderRadius: '50%',
        width: '2rem',
        height: '2rem',
        ...(kind === 'checkmark' && {
            background: theme.palette.ensightful.success[600],
        }),
        ...(kind === 'stopWatch' && {
            background: theme.palette.ensightful.warning[500],
        }),
        ...(kind === 'error' && {
            background: theme.palette.ensightful.error[700],
        }),
        ...(kind === 'task' && {
            background: theme.palette.ensightful.secondary[400],
        }),
    };
});

const CustomIcon = styled(Icon)(({ theme }) => {
    return {
        fontSize: '1.125rem',
        color: theme.palette.ensightful.shades[0],
    };
});

export default TaskStatistics;
